import React from 'react';

export default class Tonnage extends React.Component {
    render() {
        return (
            <span>
                {!isNaN(this.props.row.total_tonnes) && this.props.row.total_tonnes.toLocaleString('en-US').replace(/,/g, " ")}
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/fog/tableComponents/Tonnage.js